"use strict";

var WEDDING_POSTPONEMENT_ANNOUNCEMENTS = 'Wedding Postponement Announcements';
module.exports = {
  WEDDING_POSTPONEMENT_ANNOUNCEMENTS: WEDDING_POSTPONEMENT_ANNOUNCEMENTS,
  LETTERPRESS_SAVE_THE_DATES: 'Letterpress Save The Dates',
  LETTERPRESS_SAVE_THE_DATE_REPRINTS: 'Letterpress Save The Date Reprints',
  SAVE_THE_DATES: 'Save The Dates',
  SAVE_THE_DATE_REPRINTS: 'Save The Date Reprints',
  PHOTO_SAVE_THE_DATES: 'Photo Save The Dates',
  PHOTO_SAVE_THE_DATE_REPRINTS: 'Photo Save The Date Reprints',
  THANK_YOU_CARDS: 'Thank You Cards',
  THANK_YOU_CARD_REPRINTS: 'Thank You Card Reprints'
};